import _readOnlyError from "@babel/runtime/helpers/esm/readOnlyError";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _QuizzesSpinner;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@instructure/ui-text';
import { Spinner } from '@instructure/ui-spinner';
import { PresentationContent } from '@instructure/ui-a11y-content';
import { jsx } from '@instructure/emotion';
import t from '@instructure/quiz-i18n/format-message';
import generateStyle from './styles';
import { withStyleOverrides } from '@instructure/quiz-common';
export var QuizzesSpinner = (_dec = withStyleOverrides(generateStyle, null), _dec(_class = (_QuizzesSpinner = /*#__PURE__*/function (_Component) {
  function QuizzesSpinner(props) {
    var _this2;
    _classCallCheck(this, QuizzesSpinner);
    _this2 = _callSuper(this, QuizzesSpinner, [props]);
    _this2.state = {
      hidden: _this2.props.delay && _this2.props.delay > 0
    };
    return _this2;
  }
  _inherits(QuizzesSpinner, _Component);
  return _createClass(QuizzesSpinner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;
      if (this.props.delay > 0) {
        this.timer = setTimeout(function () {
          _this3.setState({
            hidden: false
          });
        }, this.props.delay);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    }
  }, {
    key: "mainText",
    value: function mainText() {
      var _this$props = this.props,
        color = _this$props.color,
        mainText = _this$props.mainText,
        fontSize = _this$props.fontSize;
      return jsx(Text, {
        size: fontSize,
        color: color
      }, mainText || t('Loading...'));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        size = _this$props2.size,
        minHeight = _this$props2.minHeight,
        styles = _this$props2.styles;
      var hidden = this.state.hidden;
      if (hidden) return null;
      return jsx("div", {
        css: styles.wrapper,
        style: {
          minHeight: minHeight
        }
      }, jsx("div", null, jsx(Spinner, {
        renderTitle: this.mainText(),
        size: size
      })), jsx("div", null, jsx(PresentationContent, null, this.mainText())));
    }
  }]);
}(Component), _defineProperty(_QuizzesSpinner, "displayName", 'QuizzesSpinner'), _defineProperty(_QuizzesSpinner, "componentId", "Quizzes".concat(_QuizzesSpinner.displayName)), _defineProperty(_QuizzesSpinner, "propTypes", {
  mainText: PropTypes.string,
  fontSize: PropTypes.oneOf(['x-small', 'small', 'medium', 'large', 'x-large', 'xx-large']),
  size: PropTypes.oneOf(['x-small', 'small', 'medium', 'large']),
  color: PropTypes.string,
  minHeight: PropTypes.string,
  styles: PropTypes.object,
  delay: PropTypes.number
}), _defineProperty(_QuizzesSpinner, "defaultProps", {
  mainText: null,
  size: 'large',
  fontSize: 'xx-large',
  minHeight: '500px',
  color: 'primary'
}), _QuizzesSpinner)) || _class);
export default QuizzesSpinner;